// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"BackButton_BackButton__3aM7R"};